export const ULTRASOUND_FETCH_ALL = 'ULTRASOUND_FETCH_ALL';
export const ULTRASOUND_FETCH_ALL_SUCCESS = 'ULTRASOUND_FETCH_ALL_SUCCESS';
export const ULTRASOUND_FETCH_ALL_FAIL = 'ULTRASOUND_FETCH_ALL_FAIL';
export const ULTRASOUND_SET_SORT = 'ULTRASOUND_SET_SORT';
export const ULTRASOUND_SET_PAGE = 'ULTRASOUND_SET_PAGE';
export const ULTRASOUND_SET_PAGE_SIZE = 'ULTRASOUND_SET_PAGE_SIZE';
